var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.part, _vm.$style[("part_" + (_vm.data.id))]]},[_c('div',{class:_vm.$style.part_wrap},[_c('h3',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.data.title))]),_vm._v(" "),_vm._l((_vm.data.content),function(el,index){return _c('div',{key:index,class:[
        _vm.$style.item,
        _vm.$style[("item_" + (el.icon_row) + "_" + (el.icon_col))],
        _vm.active.length > 0 &&
          _vm.active[0] === _vm.data.id &&
          _vm.active[1] === index &&
          _vm.$style.item_active ],on:{"click":function($event){return _vm.onClick([_vm.data.id, index])}}},[_vm._v("\n      "+_vm._s(el.title)+"\n      "),_c('div',{class:_vm.$style.tip},[_c('div',[_vm._v(_vm._s(el.desc))])])])})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }